import React from 'react'
import Item, { ItemLevel1, ItemLevel2 } from '../types/Item'
import Level3LayoutProps from '../types/Level3LayoutProps'
import parse from 'html-react-parser'

const IS_GOOGLE_TRANSLATE = !!window.location.host.match('bpl-bc-ca.translate.goog')

export default ({ level2active }: Level3LayoutProps) => {
  return (
    <div className="level-3" id={level2active.slug}>
      <div key={level2active.id} className={"details" + (level2active.menusLeftSidebarBlocks.length > 0 ? ' has-sidebar' : ' no-sidebar')}>
        {level2active.menusLeftSidebarBlocks.length > 0 && (
          <div className="left-column">
            {level2active.menusLeftSidebarBlocks.map(block =>
              <>
                <div className={[
                  'card',
                  'card-' + block.colour,
                  (block.cardTitle || block.description ? 'has-contents' : ''),
                  (block.description ? 'has-description' : ''),
                  (block.linkTarget ? 'has-link' : ''),
                  (block.image ? 'has-cap-image' : ''),
                ].join(' ')}>
                  {block.image && <img src={block.image.url} width={block.image.width} height={block.image.height} alt={block.image.title} />}
                  {(block.cardTitle || block.description) &&
                    <div className="contents">
                      {block.cardTitle && <h1 className="story-title">{parse(block.cardTitle)}</h1>}
                      {block.description && <p className="story-description">{block.description}</p>}
                    </div>
                  }
                  {block.linkTarget && <a className="learn-more" href={IS_GOOGLE_TRANSLATE && block.linkTarget.indexOf('https://bpl.bc.ca') > -1 ? window.location.origin + block.linkTarget.replace('https://bpl.bc.ca', '') + window.location.search : block.linkTarget}>
                    <span>{block.linkLabel ? block.linkLabel : 'Learn More'}</span>
                  </a>}
                </div>
                {block.extraInformation && parse(block.extraInformation)}
              </>
            )}
          </div>
        )}
        <div className="main-column prose prose-reset col-narrow">
          {level2active.menusMainColumn.map(block =>
            <>
              {block.type === 'heading' &&
                <>
                  <h2>{block.groupTitle}</h2>
                  {block.text && parse(block.text)}
                </>
              }
              {block.type === 'link' &&
                <div className="link-menu-tile-half">                  
                  <a target={IS_GOOGLE_TRANSLATE ? '_blank' : '_self'} href={IS_GOOGLE_TRANSLATE && block.linkTarget.indexOf('https://bpl.bc.ca') > -1 ? window.location.origin + block.linkTarget.replace('https://bpl.bc.ca', '') + window.location.search : block.linkTarget}>{block.linkTitle}</a>
                  {block.description && <p>{block.description}</p>}
                </div>
              }
            </>
          )}
        </div>
      </div>
    </div>
  )
}